import { createFileRoute } from '@tanstack/react-router';

import { CampaignAnalysisPage } from '@/features/campaign-analysis';

export const Route = createFileRoute('/workspace/$workspaceId/campaigns/analysis')({
  component: CampaignAnalysisPage,
});
